import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaInfiniteScroll from './VaInfiniteScroll.vue'

export default withConfigTransport(VaInfiniteScroll)
